import { TaskDisplay } from '@centecomm/portal-service/dist/Tasks';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface LeasingApplicationAlertProps {
    task: TaskDisplay;
}

const LeasingApplicationAlert: React.FC<LeasingApplicationAlertProps> = ({task}) => {
    const { t } = useTranslation(['tasks']);
    return (
        <div>
            <h3>{t('tasks:leasingApplicationAlert.title')}</h3>
            <Link style={{ color: 'var(--color-Action)' }} to={task.link}>
                {t('tasks:leasingApplicationAlert.message')}
            </Link>
        </div>
    );
};

export default LeasingApplicationAlert;